import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function HeroArticle() {
  const { t } = useTranslation('blogchoisir');
  const { ref, isVisible } = useScrollReveal<HTMLDivElement>(0.1);

  const navigateTo = (path: string) => {
    if (window.REACT_APP_NAVIGATE) window.REACT_APP_NAVIGATE(path);
  };

  return (
    <section id="hero-article" className="bg-white pt-24 md:pt-28 pb-8 md:pb-12">
      <div className="max-w-4xl mx-auto px-4 md:px-6 lg:px-10">
        <nav className="mb-5" aria-label="Fil d'Ariane">
          <ol className="flex items-center gap-2 text-sm text-slate-primary/50 flex-wrap">
            <li><button onClick={() => navigateTo('/')} className="hover:text-copper transition-colors">{t('bc_home')}</button></li>
            <li><i className="ri-arrow-right-s-line" /></li>
            <li><button onClick={() => navigateTo('/blog')} className="hover:text-copper transition-colors">{t('bc_blog')}</button></li>
            <li><i className="ri-arrow-right-s-line" /></li>
            <li className="text-slate-primary font-medium">{t('bc_current')}</li>
          </ol>
        </nav>

        <div
          ref={ref}
          className={`transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <span className="inline-block bg-copper/10 text-copper text-xs font-bold tracking-wide uppercase px-3 py-1 rounded-full mb-4">
            {t('hero_category')}
          </span>

          <h1 className="font-manrope font-extrabold text-slate-primary text-[40px] sm:text-4xl md:text-5xl lg:text-[52px] leading-tight mb-5">
            {t('hero_h1')}
          </h1>

          <div className="flex items-center gap-4 text-sm text-slate-primary/50 mb-8 flex-wrap">
            <span>{t('hero_author')}</span>
            <span>•</span>
            <span>{t('hero_updated')} {t('hero_date')}</span>
            <span>•</span>
            <span className="flex items-center gap-1">
              <i className="ri-time-line" /> {t('hero_readtime')}
            </span>
          </div>

          <div className="rounded-xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Professional certified roofer standing on residential roof in Quebec wearing safety harness and hard hat, inspecting shingles with tablet, suburban neighborhood of Lévis in background, overcast autumn day, authentic documentary photography style, warm natural tones, no text visible, landscape composition 16:9"
              alt="Couvreur partenaire certifié RBQ de Couvreur-Lévis.com inspectant une toiture résidentielle"
              className="w-full h-56 md:h-80 object-cover object-top"
              loading="eager"
              fetchpriority="high"
              width="800"
              height="400"
              fetchpriority="high"
              width="1200"
              height="630"
            />
          </div>
        </div>
      </div>
    </section>
  );
}